export default {
    NONE: 0,
    FIRE_PERIMETER_2020: 1, // Obsolete
    COVID: 2,
    TROPICAL_WEATHER: 3,
    FIRE_PERIMETER: 4
};
